import { useLocation, useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import { useAuth } from "../../hooks/useAuth";
import { useDispatch, useSelector } from "react-redux";
import { useAppContext } from "../../contexts/Context";
import JuniorFirst from "../../utils/results/Junior/juniorFirst";
import SeniorFirst from "../../utils/results/Senior/seniorFirst";
import NurseryFirst from "../../utils/results/Nursery/nurseryFirst";
import { KgResult } from "../../utils/results/KG/kgResult";
import JuniorSecond from "../../utils/results/Junior/juniorSecond";
import SeniorSecond from "../../utils/results/Senior/seniorSecond";
import JuniorThird from "../../utils/results/Junior/juniorThird";
import SeniorThird from "../../utils/results/Senior/seniorThird";
import React, { useEffect, useState } from "react";
import { api } from "../../api/axios";
import { fetchCurrentTerm } from "../../redux/slices/term";
import { fetchUser } from "../../redux/slices/users";
import axios from "axios";
import { CircularProgress } from "../../components/custom";
import { UserService } from "../../services/userService";
import { OverlayLoading } from "../../components/OverlayLoading";
import BasicThird from "../../utils/results/Basic/basicThird";
import BasicSecond from "../../utils/results/Basic/BasicSecond";
import BasicFirst from "../../utils/results/Basic/basicFirst";
export default function CheckResults() {
  const { identity } = useParams();
  const { term } = useParams();
  const { session } = useParams();
  // selectedClass is the class at the time of the result upload, not user.currentClass
  const { selectedClass } = useParams();
  const dispatch = useDispatch();
  const [classTeacher, setClassTeacher] = React.useState([]);
  const [studentResult, setStudentResult] = useState("");
  const [report, setReport] = useState([]);
  const [loading, setLoading] = useState(false);
  const [waiting, setWaiting] = useState(false);
  const [datePublished, setDatePublished] = useState("");
  const { studentClass, setStudentClass } = useAppContext();
  const { user, isLoading } = useSelector((state) => state.users || {});
  useEffect(() => {
    dispatch(fetchUser({ id: identity }));
  }, [identity, dispatch]);

  const navigate = useNavigate();

  // Format YYYY-MM-DD → DD/MM/YYYY
  const formatDate = (raw) => {
    if (!raw) return "";
    const parts = raw.split("-");
    if (parts.length !== 3) return raw;
    return `${parts[2]}/${parts[1]}/${parts[0]}`;
  };

  //fetch current term
  useEffect(() => {
    dispatch(fetchCurrentTerm())
      .unwrap()
      .then((res) => {
        console.log(res);
        const latestTerm = res;
        if (latestTerm?.datePublished) {
          setDatePublished(formatDate(latestTerm.datePublished));
        }
      });
  }, []);

  //to get class teacher
  const getClassTeacher = async () => {
    try {
      const result = await UserService.findUsers({
        role: "teacher",
        classHandled: user?.currentClass,
      });
      setClassTeacher(result.data.list[0]);
      setLoading(false);
      console.log(result.data.list[0]);
    } catch (error) {
      console.log(error);
    }
  };

  React.useEffect(() => {
    getClassTeacher();
  }, []);
  console.log(classTeacher);

  useEffect(() => {
    const getResults = async () => {
      setLoading(true);
      try {
        const response = await api.get(
          `/results/studentsresults/${session}/${term}/${selectedClass || user?.currentClass}`,
        );
        setWaiting(true);
        console.log("Response:", response.data.results);
        const studentAdmissionNumber = user?.admissionNumber;
        const results = response?.data.results[0]?.results?.find(
          (row) => row[0] === studentAdmissionNumber,
        );
        if (!results) {
          setLoading(true);
          setWaiting(true);
        } else if (results) {
          setLoading(false);
          setWaiting(false);
        }
        setReport(results);
        console.log(results);
      } catch (error) {
        // setReport([]);

        console.error("Error fetching results:", error);
      } finally {
        setLoading(false);
      }
    };

    getResults();
  }, [term, user, session]);
  console.log(user);

  // set student class
  useEffect(() => {
    setStudentClass(user?.currentClass);
  }, []);

  //get result template — uses selectedClass (historical class at result upload time)
  const getResultsTemplate = (term, user) => {
    // Use selectedClass from URL params so historical results show the correct class
    const classCode = selectedClass || user?.currentClass;
    switch (term) {
      case "FIRST TERM":
        if (classCode.startsWith("FGJSC")) {
          return (
            <JuniorFirst
              results={report}
              owner={user}
              session={session}
              teacher={classTeacher}
              historicalClass={classCode}
              datePublished={datePublished}
            />
          );
        } else if (classCode.startsWith("FGSSC")) {
          return (
            <SeniorFirst
              results={report}
              owner={user}
              session={session}
              teacher={classTeacher}
              historicalClass={classCode}
              datePublished={datePublished}
            />
          );
        } else if (classCode.startsWith("FGNSC")) {
          return (
            <NurseryFirst
              results={report}
              owner={user}
              session={session}
              teacher={classTeacher}
              term={term}
              historicalClass={classCode}
              datePublished={datePublished}
            />
          );
        } else if (classCode.startsWith("FGKGC")) {
          return (
            <KgResult
              results={report}
              owner={user}
              session={session}
              teacher={classTeacher}
              term={term}
              historicalClass={classCode}
              datePublished={datePublished}
            />
          );
        } else if (classCode.startsWith("FGBSC")) {
          return (
            <BasicFirst
              results={report}
              owner={user}
              session={session}
              teacher={classTeacher}
              term={term}
              historicalClass={classCode}
              datePublished={datePublished}
            />
          );
        }
      case "SECOND TERM":
        if (classCode.startsWith("FGJSC")) {
          return (
            <JuniorSecond
              results={report}
              owner={user}
              session={session}
              teacher={classTeacher}
              historicalClass={classCode}
              datePublished={datePublished}
            />
          );
        } else if (classCode.startsWith("FGSSC")) {
          return (
            <SeniorSecond
              results={report}
              owner={user}
              session={session}
              teacher={classTeacher}
              historicalClass={classCode}
              datePublished={datePublished}
            />
          );
        } else if (classCode.startsWith("FGNSC")) {
          return (
            <NurseryFirst
              results={report}
              owner={user}
              session={session}
              teacher={classTeacher}
              term={term}
              historicalClass={classCode}
              datePublished={datePublished}
            />
          );
        } else if (classCode.startsWith("FGKGC")) {
          return (
            <KgResult
              results={report}
              owner={user}
              session={session}
              teacher={classTeacher}
              term={term}
              historicalClass={classCode}
              datePublished={datePublished}
            />
          );
        } else if (classCode.startsWith("FGBSC")) {
          return (
            <BasicSecond
              results={report}
              owner={user}
              session={session}
              teacher={classTeacher}
              term={term}
              historicalClass={classCode}
              datePublished={datePublished}
            />
          );
        }
      case "THIRD TERM":
        if (classCode.startsWith("FGJSC")) {
          return (
            <JuniorThird
              results={report}
              owner={user}
              session={session}
              teacher={classTeacher}
              historicalClass={classCode}
              datePublished={datePublished}
            />
          );
        } else if (classCode.startsWith("FGSSC")) {
          return (
            <SeniorThird
              results={report}
              owner={user}
              session={session}
              teacher={classTeacher}
              historicalClass={classCode}
              datePublished={datePublished}
            />
          );
        } else if (classCode.startsWith("FGNSC")) {
          return (
            <NurseryFirst
              results={report}
              owner={user}
              session={session}
              teacher={classTeacher}
              term={term}
              historicalClass={classCode}
              datePublished={datePublished}
            />
          );
        } else if (classCode.startsWith("FGKGC")) {
          return (
            <KgResult
              results={report}
              owner={user}
              session={session}
              teacher={classTeacher}
              term={term}
              historicalClass={classCode}
              datePublished={datePublished}
            />
          );
        } else if (classCode.startsWith("FGBSC")) {
          return (
            <BasicThird
              results={report}
              owner={user}
              session={session}
              teacher={classTeacher}
              term={term}
              historicalClass={classCode}
              datePublished={datePublished}
            />
          );
        }
      default:
        return null;
    }
  };

  console.log(term, session);
  return (
    <ViewPage className="">
      {loading ? (
        <CircularProgress />
      ) : (
        <>
          {waiting ? (
            <OverlayLoading />
          ) : (
            <>
              <div className="d-flex flex-row align-items-center gap-3 px-5 pt-3">
                <button
                  onClick={() => navigate(-1)}
                  title="Back to results"
                  style={{
                    background: "none",
                    border: "1px solid #ccc",
                    borderRadius: "6px",
                    padding: "6px 12px",
                    cursor: "pointer",
                    fontSize: "18px",
                    lineHeight: 1,
                  }}
                >
                  &#8592;
                </button>
                <p className="m-0">
                  {user?.firstName}'s result for {term}, session: {session}/
                  {Number(session) + 1} will display below... kindly switch to
                  desktop mode for proper view. To download, click on the
                  download button below.
                </p>
              </div>
              {getResultsTemplate(term, user)}
            </>
          )}
        </>
      )}
    </ViewPage>
  );
}
const ViewPage = styled.div``;
